module.exports = __webpack_public_path__ + "static/media/ic_btn_conciliacion.aaf4e22f.svg";